import React from "react";
import { Container } from "../styled.ts";

const colorCodes = ["#d5939c", "#9fd593", "#939dd5", "#d38dd3"];
export const Pill = ({
  children=<></>,
  onClick = () => {},
  radius = "15px",
  padding = "8px",
  index = -1
}) => {
  return (
    <Container
      onClick={onClick}
      padding={padding}
      radius={radius}
      justifyContent="center"
      {...index>=0?{}:{border:"solid 1px #EEE"}}
      background={colorCodes[index%4]||'#FAFAFA'}
      alignItems="center"
      style={{ cursor: "pointer"}}
    >
      {children}
    </Container>
  );
};
